<template>
  <div class="tabs is-centered">
    <ul>
      <li :class="{'is-active': isActive('')}">
        <a @click="changeTab('')">All</a>
      </li>
      <li :class="{'is-active': isActive('plugin')}">
        <a @click="changeTab('plugin')">Plugins</a>
      </li>
      <li :class="{'is-active': isActive('model')}">
        <a @click="changeTab('model')">Models</a>
      </li>
      <li :class="{'is-active': isActive('personal')}">
        <a @click="changeTab('personal')">Personal</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    type() {
      return this.$store.state.plugins.type;
    }
  },
  methods: {
    isActive(type) {
      return type == this.type;
    },
    changeTab(type) {
      this.$store.dispatch("changeType", type);
    }
  },
};
</script>